var map = {
	"./accountChange.png": 1281,
	"./change.png": 4655,
	"./chart.png": 7754,
	"./clickBuy.png": 535,
	"./clickUp.png": 5468,
	"./electronicReporter.png": 2510,
	"./gear.png": 2890,
	"./lineChart.png": 1233,
	"./man.png": 1041,
	"./money.png": 7684,
	"./moneyArrow.png": 6256,
	"./moneyHouse.png": 1547,
	"./phonetalk.png": 7897,
	"./reporter.png": 5310,
	"./reporterLetter.png": 1742,
	"./seat.png": 2380,
	"./talkStocks.png": 8765,
	"./target.png": 9321,
	"./trend.png": 729,
	"./trendBear.png": 4383,
	"./trendDown.png": 8714,
	"./trendUp.png": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2601;